// Loading.js
import React from 'react';

const Loading = () => (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <div style={{ color: '#00d4ff', fontWeight: '600', letterSpacing: '0.05em', opacity: 0.85 }}>
      Loading...
    </div>
  </div>
);

export default Loading;